import React from 'react';
import { GameState } from '../types/game';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { AlertTriangleIcon, RefreshCwIcon } from 'lucide-react';
interface BankruptcyStateProps {
  gameState: GameState;
  onReset: () => void;
}
export function BankruptcyState({
  gameState,
  onReset
}: BankruptcyStateProps) {
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-danger/10 backdrop-blur-md p-4" data-id="element-1">
      <Card className="w-full max-w-xl border-danger shadow-[0_0_50px_rgba(239,68,68,0.2)] animate-slide-up" data-id="element-2">
        <div className="text-center mb-8" data-id="element-3">
          <div className="w-20 h-20 bg-danger/20 text-danger rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-4">
            <AlertTriangleIcon className="w-10 h-10" data-id="element-5" />
          </div>
          <h1 className="text-4xl font-bold text-text-primary mb-2" data-id="element-6">
            Orbit Collapsed
          </h1>
          <p className="text-xl text-text-secondary" data-id="element-7">
            Your startup ran out of cash in{' '}
            <span className="text-text-primary font-mono" data-id="element-8">
              Q{gameState.turn}
            </span>
            .
          </p>
        </div>

        <div className="bg-surface-highlight p-6 rounded-lg mb-8 border border-border" data-id="element-9">
          <h3 className="text-sm font-medium text-text-secondary uppercase tracking-wider mb-4" data-id="element-10">
            Post-Mortem
          </h3>
          <div className="space-y-3 font-mono text-sm" data-id="element-11">
            <div className="flex justify-between" data-id="element-12">
              <span className="text-text-secondary" data-id="element-13">Final Cash Balance</span>
              <span className="text-danger" data-id="element-14">
                ${Math.round(gameState.cash).toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-15">
              <span className="text-text-secondary" data-id="element-16">Last Quarter Burn</span>
              <span className="text-text-primary" data-id="element-17">
                $
                {Math.round(gameState.expenses - gameState.revenue).toLocaleString()}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-18">
              <span className="text-text-secondary" data-id="element-19">Team Size</span>
              <span className="text-text-primary" data-id="element-20">
                {gameState.engineers + gameState.sales} people
              </span>
            </div>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-21">
          <Button onClick={onReset} size="lg" variant="danger" className="w-full md:w-auto min-w-[200px]" data-id="element-22">
            <RefreshCwIcon className="w-4 h-4 mr-2" data-id="element-23" />
            Start Over
          </Button>
        </div>
      </Card>
    </div>;
}